import { motion } from "framer-motion";
import { IMAGES } from "@/lib/site";

const ITEMS = [
  { src: IMAGES.edging, label: "Edging & whipper snipping", span: "lg:col-span-2 lg:row-span-2" },
  { src: IMAGES.mower, label: "Lawn mowing" },
  { src: IMAGES.gardenPath, label: "Garden clean-ups" },
];

const reveal = {
  initial: { opacity: 0, scale: 0.96 },
  whileInView: { opacity: 1, scale: 1 },
  viewport: { once: true, margin: "-40px" },
};

export const Gallery = () => {
  return (
    <section id="gallery" className="py-20 lg:py-28 bg-sand scroll-mt-20">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-12">
          <div className="max-w-xl">
            <p className="text-xs tracking-[0.2em] uppercase text-lawn font-bold mb-3">Our work</p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-ink">
              Results that speak for themselves
            </h2>
          </div>
          <p className="text-ink-soft sm:max-w-md">
            We provide reliable, affordable, and high-quality lawn and property maintenance you can count on. From regular lawn care and garden upkeep to one-off clean-ups and detailed property maintenance, we take pride in delivering professional results with attention to detail. Our goal is to keep your outdoor spaces looking neat, healthy, and well cared for, while offering friendly service and great value every step of the way.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 auto-rows-[180px] sm:auto-rows-[230px]">
          {ITEMS.map((it, i) => (
            <motion.figure
              key={it.label}
              data-testid={`gallery-item-${i}`}
              {...reveal}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className={`relative rounded-2xl overflow-hidden group ${it.span || ""}`}
            >
              <img
                src={it.src}
                alt={it.label}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-forest-dark/70 via-forest-dark/0 to-transparent" />
              <figcaption className="absolute bottom-4 left-4 text-cream font-heading font-bold text-sm sm:text-base">
                {it.label}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
